import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'product_page-view_reorder_banner-action_category_impression';

/**
 * https://www.notion.so/faire/Reorder-Insights-In-Journey-21c2efb5c25a803887faf2f243bc4315

Event to track view impressions on the reorder banner on the PDP.
 */
export function trackProductPageViewReorderBannerActionCategoryImpression(
  productToken: string,
  retailerToken: string,
  message: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { productToken, retailerToken, message },
  });
}
